module.exports = __webpack_public_path__ + "img/bell.d4831e3d.svg";